<template>
  <div class="landing-page" :style="{ backgroundImage: `url(${designUrl}LandingPage.png)` }">
    <div class="card">

      <div class="illustration-wrapper">
        <img id="centre-piece" src="/centre.png" />
      </div>

      <div class="heading">
        <h1>Find Your <span class="highlight">New Furry</span><br />Best Friend</h1>
      </div>

      <p class="subtitle">Connect to pets in your location</p>

      <div class="button-group">
        <div id="googleSignInButton" class="google-btn"></div>
      </div>

    </div>
  </div>
</template>

<script>
const backendUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'LandingPage',
  data() {
    return {
      designUrl: '/background_designs/',
    };
  },
  mounted() {
    this.loadGoogleScript();
  },
  methods: {
    loadGoogleScript() {
      if (window.google?.accounts?.id) {
        this.initGoogleLogin();
        return;
      }

      const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      if (!existing) {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }

      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (window.google?.accounts?.id) {
          clearInterval(interval);
          this.initGoogleLogin();
        } else if (attempts > 50) {
          clearInterval(interval);
          console.error('❌ Google GSI failed to load after 5s');
        }
      }, 100);
    },

    initGoogleLogin() {
      window.google.accounts.id.initialize({
        client_id: '452147930843-at6leqa9ruodie7fbuq2mbhvk5iafatu.apps.googleusercontent.com',
        callback: this.handleCredentialResponse,
        ux_mode: 'popup'
      });

      window.google.accounts.id.renderButton(
        document.getElementById('googleSignInButton'),
        {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          width: 300
        }
      );
    },

    async handleCredentialResponse(response) {
      console.log('🟢 Google callback fired');

      try {
        const { credential } = response;
        const payload = JSON.parse(atob(credential.split('.')[1]));
        const email = payload.email;
        const fullname = payload.name;

        console.log('📤 Sending to backend:', email, fullname);

        const res = await fetch(`${backendUrl}/api/auth/google-login`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, fullname })
        });

        console.log('📥 Raw response:', res);

        if (!res.ok) {
          const text = await res.text();
          console.error(`❌ Server error ${res.status}:`, text);
          throw new Error(`Login failed with status ${res.status}`);
        }

        const data = await res.json();
        console.log('🟢 Backend response:', data);

        console.log('🟢 Emitting user-logged-in NOW');
        this.$emit('user-logged-in', {
          ...data.user,
          isNew: data.isNew
        });

      } catch (err) {
        console.error('💥 Google login FAILED:', err);
      }
    },

    handleSignUp() {
      this.$emit('change-page', 'SignupPage');
    },

    handleLogin() {
      this.$emit('change-page', 'LoginPage');
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.landing-page {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(1.5rem, 4vw, 3rem);
}

/* ── Card ── */
.card {
  width: 100%;
  max-width: 500px;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f0e0ff;
  padding: 48px 36px 40px;
  box-shadow: 0 8px 32px rgba(186, 113, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

#centre-piece {
  width: clamp(180px, 35vw, 260px);
  height: clamp(180px, 35vw, 260px);
  object-fit: contain;
}

/* ── Illustration ── */
.illustration-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* ── Heading ── */
.heading {
  text-align: center;
}

.heading h1 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.3;
  letter-spacing: -0.4px;
}

.highlight {
  color: #ba71ff;
}

/* ── Subtitle ── */
.subtitle {
  font-size: 14px;
  color: #aaa;
  font-weight: 500;
  text-align: center;
  margin-top: 4px;
  margin-bottom: 8px;
}

/* ── Button group ── */
.button-group {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.google-btn {
  transition: transform 0.2s ease;
}

.google-btn:hover {
  transform: scale(1.04);
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .card {
    border-radius: 20px;
    padding: 28px 20px 24px;
  }

  .heading h1 { font-size: 1.5rem; }
  .subtitle   { font-size: 13px; }
}
</style>